import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { __ } from '@wordpress/i18n';
import { closeSmall } from '@wordpress/icons';
import { isValueEmpty, noop } from '@wp-g2/utils';
import React from 'react';
import { Button } from '../Button';
import { View } from '../View';

function SearchInputClearButton(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, ["onClick", "value"]);

  var hasValue = !isValueEmpty(value);
  return /*#__PURE__*/React.createElement(View, {
    css: {
      opacity: hasValue ? 1 : 0,
      pointerEvents: hasValue ? 'cursor' : 'none'
    }
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    "aria-label": __('Clear'),
    icon: closeSmall,
    iconSize: 10,
    isRounded: true,
    onClick: function handleOnClick(event) {
      event.stopPropagation();
      onClick(event);
    },
    size: "xxSmall",
    tabIndex: -1
  }, otherProps)));
}

export default /*#__PURE__*/React.memo(SearchInputClearButton);